import React from "react";

function article_1() {
	return {
		date: "3 July 2024",
		title: "Swoop Studio: My First Startup Venture!",
		description:
			"I launched a startup project aiming to revolutionize video production through AI-driven automation.",
		keywords: [
			"Innovation",
			"LLMs",
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.paragraph {
					margin-bottom: 20px;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">
						Video production has traditionally been a labor-intensive endeavor, requiring a significant investment of time and specialized skills. However, the rise of Large Language Models (LLMs) offered a fresh perspective—an opportunity to reimagine the entire process. What if we take advantage of ChatGPT to automate video production from start to finish? Could a simple topic input be transformed into a fully polished video with minimal human intervention? Fueled by this vision, me and my tech-savvy peers launched Swoop Studio—a startup project dedicated to pushing the boundaries of modern video production and redefining what’s possible through collaboration and AI technology.
					</div>
					<div className="paragraph">
						The concept was ambitious. We envisioned a platform that could take a single topic, process it through LLMs, and generate a polished 10-minute video—all within just 30 minutes. It was a tall order, but the potential was enormous. The idea of empowering anyone, regardless of technical expertise, to create high-quality video content was exhilarating. However, the path to realizing this vision was anything but straightforward.
					</div>
					<div className="paragraph">
						Our team was as diverse as it was talented, with each member bringing a unique set of skills to the table. We had backend developers, model fine-tuning experts, and frontend designers—all passionate and brimming with ideas. But with diversity came differing opinions, especially when it came to the project’s direction and technical approach. Our challenge was not just technical but also managerial—how could we align our visions and harness our collective strengths to create something truly groundbreaking?
					</div>
					<div className="paragraph">
						To navigate all these, I knew we needed a structure that allowed for both creativity and discipline. I introduced Agile methodologies, breaking our massive project into smaller, manageable sprints. This approach not only made the workload feel less overwhelming but also allowed us to celebrate small victories along the way, keeping morale high. Every other day, we held stand-up meetings to check in on progress, share insights, and tackle any roadblocks head-on. These sessions became the heartbeat of our project, ensuring that everyone stayed in sync and that no problem went unaddressed for long. Beyond that, I facilitated brainstorming sessions where every idea was welcomed, no matter how out-of-the-box. These sessions were where the magic happened. They allowed us to see problems from multiple perspectives and come up with creative solutions that none of us could have devised alone. It was in these moments of collective brainstorming that we truly became a team, united by a shared vision and a common goal.
					</div>
					<div className="paragraph">
						After months of hard work, late nights, and countless lines of code, we did it. We developed a working prototype of our automation tool—an incredible feat that could take a simple topic and, within 30 minutes, transform it into a polished, 10-minute video. Seeing it in action for the first time was nothing short of thrilling. The sense of accomplishment we felt was immense, knowing that we had turned a lofty idea into a tangible, functioning product.
					</div>
					<div className="paragraph">
						Though we didn’t secure funding, the experience was far from a failure. It was a testament to the power of collaboration, the importance of perseverance, and the potential of innovative thinking. Swoop Studio taught us that even the most daunting challenges can be overcome when you have a team that believes in the vision and is committed to making it a reality. The lessons learned, the skills gained, and the bonds formed were invaluable.
					</div>
					<div className="paragraph">
					In the end, Swoop Studio was more than just a startup project—it was a journey of discovery, growth, and relentless innovation. It showed us what’s possible when you dare to dream big and work together to turn that dream into reality. And as we look to the future, the experience of Swoop Studio continues to inspire us to push the boundaries of what’s possible in the world of technology and beyond.
					</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

function article_2() {
	return {
		date: "7 May 2022",
		title: "When the Pandemic Brings Us Closer: Perspective from a Community Volunteer",
		description:
			"A reflection on how the pandemic strengthened community bonds, drawing from my personal experience as a community volunteer.",
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.paragraph {
					margin-bottom: 20px;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		keywords: [
			"Community Volunteers",
			"COVID-19"
		],
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">
						"Where is Building XX?" I've heard the question so often, and yet, though I have lived on Ziteng Street for nearly two decades, my invariable response was a smile that was really just a question mark itself.
					</div>
					<div className="paragraph">
						I'm sure this is a familiar script for most of us: so caught up in our whirlwind lives, the people next door remain just faces we pass by. But then, COVID-19 burst onto the scene, and I found myself, as a community volunteer, diving headfirst into the frontline response. Who knew that simply knowing your way around a bunch of buildings could be your ticket to becoming the neighborhood's unsung hero?					</div>
					<div className="paragraph">
						Managing the maze of Minhang District Ziteng Street Neighborhood, with its 20+ buildings, became a game of strategic navigation. It wasn't merely a case of avoiding the proverbial bullet; it was a question of getting heart medication to Mrs. Wang and a week's stash of groceries to Mr. Zhang. Having to do all this in Shanghai's summer heat, in what felt like a walking sauna thanks to the protective gear, added to my daily fitness regime something of a tweak. The need to juggle tasks in pandemic mode-from mundane to mind-boggling-turned us all into jacks-of-all-trades. One minute I'm a permit officer, the next some sort of makeshift dog whisperer for quarantined pooches. Whoever said community work isn't diverse?					</div>
					<div className="paragraph">
						The payoff, though, was in the small moments - those genuine 'thank you's from the residents that made all the sweat worth it. Through all this, I watched my perception of community work evolve from some vague notion into something palpably real. Every door knocked, every parcel delivered, shortened the emotional distance between us. This pandemic, paradoxically, ironically, thrust us to our breaking points and yet pulled us together, knitting a closer, more compassionate community fabric.					</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

function article_3() {
	return {
		date: "12 Nov 2023",
		title: "Navigating Independent Web App Development: A Journey with Jack O Translate",
		description:
			"Hear about my first independent web development experience.",
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: left;
				}

				.paragraph {
					margin-bottom: 20px;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		keywords: [
			"Application Development",
			"Ruby on Rails"
		],
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">
						It all began with a simple frustration. 
					</div>
					<div className="paragraph">
						While texting my international friends and emailing professors, I realized that most translation apps fell short—they provided literal translations but missed the subtle nuances that different contexts demanded. I found myself wishing for a tool that could adapt its tone and context, making the translations more accurate and meaningful. This small, nagging thought eventually snowballed into something bigger: the inspiration for "Jack O Translate”.
					</div>
					<div className="paragraph">
						Creating "Jack O Translate" wasn’t just about building another translation app. It was my first true dive into independent web development, where I had to apply every bit of programming knowledge I’d gathered and then some. I wanted this app to stand out, to do more than just convert words from one language to another. By integrating the OpenAI API, I aimed to provide users with a translation experience that could adjust its tone to capture what one wanted to say.
					</div>
					<div className="paragraph">
						I used Ruby on Rails for the backend, complemented with HTML and Bootstrap up front; sprinkled a little JavaScript and CSS on top to give it all those interactive touches. It was quite a challenge. This was not a school assignment, but my project-my responsibility; hence, there was no predefined structure, no professor's hand guiding me. I had to conceptualize, design, and architect the whole thing from scratch.
					</div>
					<div className="paragraph">
						Deploying the app to Heroku brought its own set of hurdles, especially when I hit an internal server error while adding email confirmation via the Devise gem. Everything worked fine locally, but once live on Heroku, the dreaded 500 error appeared, and the usual debugging tools offered no help. After hours of combing through online forums, tweaking configurations, and enhancing RSpec tests, I finally found a solution. With advice from my TA, I switched from Gmail SMTP to SendGrid SMTP, resolving the issue and pushing the project forward.					</div>
					<div className="paragraph">
						"Jack O Translate" turned out to be more than just a technical challenge. It was a journey of persistence, innovation, and self-reliance. I had to navigate uncharted waters, solve problems on the fly, and stretch my capabilities beyond what I thought was possible. The experience not only deepened my understanding of software engineering but also solidified my passion for it.					</div>
					<div className="paragraph">
						As I move forward in my journey as a prospecting software engineer, I carry with me the lessons learned from this project—lessons in creativity, problem-solving, and the sheer joy of turning a small idea into something tangible and impactful. "Jack O Translate" started as a solution to a personal frustration, but it grew into a testament to what can be achieved when you push beyond your comfort zone and embrace the challenges that come your way.
					</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

const myArticles = [article_1, article_3, article_2];

export default myArticles;
